import { render, staticRenderFns } from "./CreateMilestoneModal.vue?vue&type=template&id=6c1b6532&scoped=true"
import script from "./CreateMilestoneModal.vue?vue&type=script&lang=js"
export * from "./CreateMilestoneModal.vue?vue&type=script&lang=js"
import style0 from "./CreateMilestoneModal.vue?vue&type=style&index=0&id=6c1b6532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1b6532",
  null
  
)

export default component.exports